import { createFileRoute } from '@tanstack/react-router'
import PageForgot from '@/pages/account/forgot'

export const Route = createFileRoute('/app/account/forgot')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PageForgot />
}
